$(function () {
	var $carousels = $('[data-destinationcarousel]');
    initCarousels($carousels);

	function initCarousels($carousels) {
		$carousels.each(function () {
			const $carousel = $(this);
            $carousel.owlCarousel({
                loop: true,
                dots: false,
                nav: false,
                center: true,
                margin: 24,
                responsive: {
                    0: {
                        items: 1.3,
                    },
                    900: {
                        items: 2,
                    },
                    1100: {
                        items: 4,
                    }
                },
                autoplay: false
            });
		});
	}
});